import { defineEvent } from '../types/event';
export var GIFT_OPTIONS_PROMPT_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Gift_Options_Prompt_Click'
        }
    ]
});
